import React from 'react';
import { useLocation } from 'react-router-dom';
import BackButton from './BackButton';
import BottomNavigation from './BottomNavigation';

const AppLayout = ({ children }) => {
  const location = useLocation();

  // Don't show layout elements on login, register, or welcome pages
  const hideLayout = ['/', '/login', '/register', '/role-selection', '/lawyer-profile', '/profile'].includes(location.pathname);
  
  // Only lawyer chat pages should handle their own scrolling (they have LawyerLayout)
  const isLawyerChatPage = location.pathname.includes('/lawyer-chat-conversation');

  if (hideLayout) {
    return <div className="min-h-screen w-full">{children}</div>;
  }
  
  if (isLawyerChatPage) {
    return <div className="h-screen w-full overflow-hidden">{children}</div>;
  }

  return (
    <div className="min-h-screen w-full bg-bg-primary">
      {/* Responsive Screen Content Structure */}
      <div className="flex flex-col min-h-screen w-full">
        {/* Main Content Area with proper scrolling */}
        <div className="flex-1 overflow-y-auto w-full">
          {children}
        </div>
        
        {/* Responsive Bottom Navigation */}
        <BottomNavigation />
      </div>
    </div>
  );
};

export default AppLayout; 